module.exports = __webpack_public_path__ + "static/media/share-get-zan.eeba6743.png";